export enum QuantitySettingType {
  Surcharge = "Surcharge",
  SurchargePercentage = "SurchargePercentage",
  Discount = "Discount",
  DiscountPercentage = "DiscountPercentage",
  TotalFixedPrice = "TotalFixedPrice"
}
